<template>
  <div>
    <router-link to="/customers">View your customers</router-link>
    <a-card style="margin: 20px 0;" :bordered="false" class="needColumn">
      <div>
        <a-avatar :src="`${API_URL}${customer.logo}`"/>
      </div>
      <p>
        Validate and Issue Reward for {{customer.first_name}} {{customer.last_name}}
      </p>
    </a-card>

    <a-card style="margin: 20px 0;" title="Points Log" :bordered="false">
      <a-table :columns="columns"
               :dataSource="rewardsLog"
               :pagination="{ pageSize: 10 }"
               rowKey="updated_at">
        <span slot="validateReward" slot-scope="text,record">
          <a-button @click="showModal(record)"
                    v-if="record.reward_status === false"
                    type="primary">
            validate
          </a-button>
        </span>
        <span slot="reward_status"
              slot-scope="text,record"
              v-if="record.reward_status === true">
          Claimed
        </span>
        <span slot="reward_status"
              slot-scope="text,record"
              v-else>
          Earned
        </span>
        <span slot="updated_at"
              slot-scope="text,record">
            {{moment(record.updated_at).format('D-MMM YYYY @ h:mma')}}
        </span>
      </a-table>
      <a-modal
        v-model="validateReward"
        onOk="handleOk"
        title="Validate Reward - Confirmation"
      >
        <p>Validate and Issue reward?</p>
        <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" @click="handleOk">
            Validate reward
          </a-button>
        </template>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {API_URL} from '../../constants'
import moment from 'moment'

const columns = [{
  title: 'Member Name',
  dataIndex: 'name',
  width: 250,
}, {
  title: 'Reward Name',
  dataIndex: 'reward_name',
  width: 120,
}, {
  title: 'Points',
  dataIndex: 'points_count',
  width: 250,
}, {
  title: 'Status',
  dataIndex: 'reward_status',
  scopedSlots: { customRender: 'reward_status' },
  width: 100,
}, {
  title: 'Updated',
  dataIndex: 'updated_at',
  scopedSlots: { customRender: 'updated_at' },
  width: 150,
}, {
  title: 'Validated By',
  dataIndex: 'agent_name',
  width: 150,
}, {
  title: 'Action',
  dataIndex: 'validateReward',
  width: 150,
  scopedSlots: { customRender: 'validateReward' },
} ]

export default {
  name: 'GivePoints',
  data () {
    return {
      columns,
      API_URL,
      validateReward: false,
      walletId: null,
    }
  },
  mounted () {
    this.$store.dispatch('loyalty/getRewardsLog', this.$route.params.user_id)
  },
  methods: {
    moment,
    navigate (name, params) {
      this.$router.push({name, params})
    },
    showModal (record) {
      this.validateReward = true
      this.walletId = record.id
    },
    handleOk () {
      this.$store.dispatch('loyalty/validateReward', {userId: this.$route.params.user_id, walletId: this.walletId})
      this.validateReward = false
    },
    handleCancel () {
      this.validateReward = false
    },
  },
  computed: {
    ...mapState({
      rewardsLog: state => {
        return state.loyalty.rewards.map(reward => ({
          id: reward.id,
          name: `${reward.user.first_name} ${reward.user.last_name}`,
          reward_name: reward.offer && reward.offer.name,
          points_count: '100/100',
          reward_status: reward.redeemed,
          updated_at: reward.created_at,
          agent_name: reward.agent && reward.agent.name,
        }))
      },
      user: state => state.auth.user,
      customer: state => state.loyalty.customer,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
</style>



// WEBPACK FOOTER //
// src/components/Customers/ManageRewards.vue